import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";
import ImageConverterImageListScreen from "../image_converter/ImageConverterImageListScreen";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function ImageResizerMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "Resize Images & Compress Images Free",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/image_resizer", title: "Reduce Image Size" },
    data2: { link: "/image_resizer", title: "Compress Image Under 300KB" },
    data3: { link: "/image_resizer", title: "Resize Image To Passport Size" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Online"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Resize images online easily. Change image dimensions, compress photos, and optimize pictures quickly with our fast and secure image resizer tool."
      ></meta>
      <meta
        name="keywords"
        content="image resizer, resize images online, resize image, photo resizer, image size reducer, image dimension changer, resize photos online, online image resizer, picture resizer, image editor online, compress and resize images, resize images for web, resize images for social media, image optimization tool, free image resizer, image compressor, compress image under 300KB, compress images under 200KB, compress images under 100KB, signature compressor, image resizer for govt form, passport resizer, stamp resizer, reduce image size,"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <ImageConverterImageListScreen title={title} />
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{
              "image/*": [], // This MIME type accepts all image formats
            }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Image Resizer & Image Compressor website offers a fast, secure, and efficient way to resize and compress images without needing an internet connection. Built to work fully offline, this powerful tool processes images directly on your device, ensuring complete privacy and data security. Whether you need to reduce image file size, resize photos for websites, social media, or mobile apps, or optimize images for storage and sharing, this platform delivers high-quality results with minimal quality loss. The website supports popular formats such as JPG, PNG, WebP, and more, making it a reliable photo resizer and image compression tool for personal and professional use. Users can also choose online functionality when required, making it flexible enough to work as an image resizer online and image compressor online while still providing offline performance. With an intuitive interface and fast processing engine, users can resize images in bulk, compress large photos, and optimize visuals for SEO and faster page loading. Ideal for designers, developers, students, and content creators, this tool helps improve website performance and save storage space. If you are looking for a secure image resizer, a powerful image compressor, or an easy-to-use photo resizer that works offline, this website provides a complete solution for modern image optimization needs." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Resize",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Image Resizer"
            why_use={[
              {
                title: "Reduce Image File Size",
                description:
                  "Our image compressor reduces large image file sizes without major quality loss, making it easier to upload, share, and store images using an image compressor online or offline.",
              },
              {
                title: "Improve Website Speed and SEO",
                description:
                  "Using an image resizer and image compressor helps optimize images for faster page loading, improving user experience and SEO rankings.",
              },
              {
                title: "Resize Images for Multiple Platforms",
                description:
                  "Our image resizer online or offline allows users to resize photos for websites, social media, emails, and mobile apps. Our photo resizer ensures perfect image dimensions.",
              },
              {
                title: "Offline Processing for Privacy",
                description:
                  "This offline image resizer & image compressor processes images directly on your device, keeping files private without uploading them to an image compressor online service.",
              },
              {
                title: "Save Storage Space",
                description:
                  "Image compression reduces storage usage on devices and cloud platforms, making an image compressor ideal for managing large photo collections.",
              },
              {
                title: "Preserve Image Quality",
                description:
                  "Advanced image compression tools maintain visual clarity while reducing file size, ensuring professional-quality images after resizing.",
              },
              {
                title: "Faster Sharing and Uploading",
                description:
                  "Smaller image sizes created with an image resizer or image compressor online upload faster across websites, messaging apps, and email platforms.",
              },
              {
                title: "Supports Multiple Image Formats",
                description:
                  "Modern image resizer and image compressor tools support JPG, PNG, WebP, and other popular formats for flexible image optimization.",
              },
              {
                title: "Useful for Professionals and Individuals",
                description:
                  "Designers, developers, marketers, students, and everyday users rely on photo resizer and image compressor tools for efficient image management.",
              },
            ]}
          />
          {/* FAQ */}
          <MiscFAQ
            faq_list={[
              {
                title: "How can I resize an image online for free?",
                description:
                  "Visit ShivaPDF.com and open the Image Resizer tool. Select the image you want to resize, enter your desired width and height or choose an available resizing option, and process the image. Download the resized image to your device.",
              },
              {
                title: "Can I resize images offline?",
                description:
                  "You can resize images offline if the tool and all required processing resources are available locally on your device. You may need an internet connection to load the website and its required scripts before using the tool offline.",
              },
              {
                title: "Can I resize images without uploading them?",
                description:
                  "If ShivaPDF processes images entirely in your browser, you can resize them without uploading the files to a remote server. Local processing can help protect the privacy of personal photos and confidential images.",
              },
              {
                title: "Is it safe to resize images locally in a browser?",
                description:
                  "Local image resizing can help protect privacy because your files do not need to be sent to a remote server. If you are working with sensitive images, verify that the tool performs resizing locally and does not transmit your files.",
              },
              {
                title: "What is an image resizer?",
                description:
                  "An image resizer is a tool that changes the width and height of an image. It helps prepare pictures for websites, social media, documents, online forms, profile photos, and other uses that require specific image dimensions.",
              },
              {
                title: "Can I resize an image to a custom width and height?",
                description:
                  "Yes, if custom dimensions are supported, you can enter the required width and height in pixels. This is useful when an image must fit a specific website layout, document, profile picture, or application requirement.",
              },
              {
                title: "Can I resize an image without losing quality?",
                description:
                  "Reducing image dimensions can preserve good visual quality when the output settings are appropriate, but some detail may be lost. Enlarging a small image can make it look blurry or pixelated because new image detail must be interpolated.",
              },
              {
                title: "Can I resize an image without stretching it?",
                description:
                  "Yes, preserve the image's aspect ratio when changing its dimensions to avoid stretching or squashing the content. If the tool supports a locked aspect ratio option, enable it before entering the new width or height.",
              },
              {
                title: "What is the aspect ratio of an image?",
                description:
                  "The aspect ratio is the proportional relationship between an image's width and height. Keeping the original aspect ratio while resizing helps preserve the shape of people, objects, and other content in the image.",
              },
              {
                title: "Can I resize an image in pixels?",
                description:
                  "Yes, image dimensions are commonly measured in pixels. If the tool supports pixel-based resizing, enter your target width and height to create an image suitable for websites, apps, thumbnails, or digital documents.",
              },
              {
                title: "Can I resize an image to a specific file size in KB?",
                description:
                  "Resizing an image to a target file size, such as 100 KB or 200 KB, depends on whether the tool includes a file size or compression option. Reducing dimensions and adjusting image quality may help reduce file size, but the exact result depends on the image.",
              },
              {
                title: "Does resizing an image reduce its file size?",
                description:
                  "Reducing an image's pixel dimensions often reduces its file size, although the result depends on the image format and compression settings. If you need a smaller file, check whether the tool also offers image compression or output quality controls.",
              },
              {
                title: "Can I resize JPG and PNG images?",
                description:
                  "You can resize JPG and PNG images when these formats are supported by the tool. Check the Image Resizer page for the available input and output formats.",
              },
              {
                title: "Can I resize WebP images?",
                description:
                  "WebP images can be resized if the tool and browser support that format. Select your image, specify the desired dimensions, and download the result in an available output format.",
              },
              {
                title: "Can I resize an image without cropping it?",
                description:
                  "Yes, resizing changes an image's dimensions without necessarily removing any content. Cropping is a separate operation that cuts away part of an image, so choose a resizing option that preserves the full image if you do not want content removed.",
              },
              {
                title: "Can I resize multiple images at once?",
                description:
                  "Batch resizing is available only if the tool supports selecting and processing multiple images in one operation. Check the ShivaPDF Image Resizer page for batch processing options and any file limits.",
              },
              {
                title: "Can I resize images on my mobile phone?",
                description:
                  "You can access ShivaPDF.com through a supported browser on an iPhone, Android phone, or tablet. Select an image from your device and use the available resizing options to adjust its dimensions.",
              },
              {
                title: "Do I need to install software to resize images?",
                description:
                  "No separate desktop application is required when using a browser-based image resizer. Open ShivaPDF.com in a supported browser, select your image, and follow the available steps to resize and download it.",
              },
              {
                title: "Can I enlarge a small image?",
                description:
                  "You can enlarge an image by increasing its width and height when the tool supports custom dimensions. However, enlargement cannot restore details that were not present in the original image, so the result may look less sharp.",
              },
              {
                title: "Why does my resized image look blurry?",
                description:
                  "A resized image may look blurry if it has been enlarged significantly, reduced to very small dimensions, or saved with strong compression. Try using suitable dimensions and output quality settings to achieve a clearer result.",
              },
              {
                title: "Will resizing change the original image?",
                description:
                  "The resizing process can produce a separate output file so you can keep the original image unchanged. Save the resized version separately if you want to preserve the original dimensions and quality.",
              },
              {
                title: "How do I download a resized image?",
                description:
                  "After resizing finishes, select the download option to save the new image to your device. Open the downloaded file to check its dimensions, visual quality, and file size.",
              },
              {
                title: "Why should I use ShivaPDF to resize images?",
                description:
                  "ShivaPDF provides browser-based tools for common image and PDF tasks without requiring separate desktop software. Use the Image Resizer to prepare images for websites, forms, documents, social media, and other digital projects.",
              },
            ]} />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1614646280}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Recommended Tools */}
          <MiscRecommendedPages />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default ImageResizerMain;
